import { Spinner } from '@/components/ui';

/**
 * Shown while the session is being restored and while a lazy route chunk loads.
 *
 * Deliberately minimal: a wordmark and a spinner, centred, on the app background.
 * Anything richer would itself shift once the real screen mounts.
 */
export function FullPageLoader({ label = 'Loading Energise Studio…' }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas">
      <BrandMark className="h-9 w-9" />
      <Spinner size="sm" label={null} className="text-accent" />
      <p className="text-sm text-muted">{label}</p>
    </div>
  );
}

/** The Energise Studio mark — a barbell. Matches the PWA icon. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <rect width="32" height="32" rx="7" className="fill-accent" />
      <g className="fill-fg-onAccent">
        <rect x="9" y="14.75" width="14" height="2.5" rx="1" />
        <rect x="7.5" y="11" width="2.5" height="10" rx="1" />
        <rect x="22" y="11" width="2.5" height="10" rx="1" />
        <rect x="5" y="12.75" width="2" height="6.5" rx="1" />
        <rect x="25" y="12.75" width="2" height="6.5" rx="1" />
      </g>
    </svg>
  );
}

/** Inline variant for route transitions inside a layout that is already painted. */
export function RouteFallback() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <Spinner size="lg" label="Loading screen" className="text-accent" />
    </div>
  );
}
